export default __webpack_public_path__ + "static/media/dial.ae0d97db.svg";